import createApiRequest from '@/lib/axios/createApiRequest';
import type Opportunity from '@/types/api/Opportunity';
import type PutOpportunity from '@/types/api/PutOpportunity';

export default function putOpportunity(
  opportunityId: string,
  data: PutOpportunity,
) {
  return createApiRequest<{ opportunity: Opportunity }>({
    data,
    method: 'put',
    path: `opportunities/${opportunityId}`,
    throwErrors: true,
  });
}
